import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import { isMobileScreen } from '../utils/breakpoints';
import Modal from '../Modal';
import ModalHeader from '../ModalHeader';
import ModalBody from '../ModalBody';

import './LongTermModal.scss';

const LongTermModal = ({ isOpen, handleClose }) => {
  return (
    <Modal
      ariaHideApp={false}
      contentLabel="modal"
      isOpen={isOpen}
      onRequestClose={handleClose}
      size={isMobileScreen() ? 'fullscreen' : 'medium'}
    >
      <ModalHeader
        // className={styles['long-term-modal__header']}
        className="long-term-modal__header"
        dataTest="long-term-modal-close"
        onRequestClose={handleClose}
      />
      <ModalBody
        // className={styles['long-term-modal__body']}
        className="long-term-modal__body"
      >
        <h2>
          <strong>{trans('homecard.label.long-term')}</strong>
        </h2>
        <p>{trans('search.booknow-card-label.tooltip.permanent.es')}</p>
      </ModalBody>
    </Modal>
  );
};

LongTermModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired
};

export default LongTermModal;
